// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"128":"9f3ecaa4","782":"70d223dd"}[chunkId] + ".css";
};